export enum UploadStatus {
    PENDING="PENDING",
    UPLOADING="UPLOADING",
    UPLOADED="UPLOADED",
    FAILED="FAILED"
}